<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.admin.activate_member.fields.user_id.label')"
                    :placeholder="$t('forms.admin.activate_member.fields.user_id.placeholder')"
                    :isRequired="true"
                    :error="error"
                    type="number"
                    name="userId"
                    valuePath="userId"
                    @change="inputChange($event)"
                ></text-input>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button :isProcessing="isLoading" type="primary" :label="$t('common.microcopy.activate')"></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import AdminAPI from 'api/AdminAPI'
    import LoginType from 'enums/login_type.enum'
    import RoutesEnum from 'enums/routes.enum'

    export default {
        mixins: [FormMixin],

        data: () => ({
            error: '',
        }),

        methods: {
            inputChange(event) {
                this.error = ''
                this.change(event)
            },
            submit() {
                this.submitForm(AdminAPI.activateMember(Number(this.data.userId)))
                    .then(async (res) => {
                        const adminAccessToken = localStorage.getItem('access_token')
                        const adminRefreshToken = localStorage.getItem('refresh_token')
                        const adminLoginType = localStorage.getItem('login_type')
                        this.$auth.createSession({
                            accessToken: res.payload.access_token,
                            refreshToken: res.payload.refresh_token,
                            loginType: LoginType.BASIC,
                            adminAccessToken,
                            adminRefreshToken,
                            adminLoginType,
                        })
                        await this.$router.push({ name: RoutesEnum.INDEX.HOME })
                        window.location.reload()
                    })
                    .catch(() => {
                        this.error = this.$t('forms.admin.activate_member.user_not_active')
                    })
            },
        },
    }
</script>
